import React from 'react';

export default function ArtReq() {
  return (
<>
    <section className="art-for-embroidery page-center padding40tb">
      {/* Header */}
      <div className="text-center mb-6">
        <h2>Art For Embroidery</h2>
      </div>

      {/* Main Points */}
      <div className="main-points mb-8">
        <h3>Main Points Of Embroidery File Review</h3>
        <p>
          The first step in embroidered custom decorated apparel is receiving and reviewing client art files. All digital files are redrawn as virtual stitches to communicate the design to the embroidery machine. The process for redrawing a design or logo as stitches is called digitizing. The cleanest files produce the most perfect embroidery.
        </p>
        <p>
          <strong style={{ color: '#c43235' }}>Letter Size</strong> - Letters can be no smaller than .25” or they will not embroider well.<br />
          <strong style={{ color: '#c43235' }}>Detail</strong> - Super fine detail will likely be compromised. Most embroidered logos are small by nature, thread is a fixed width, and the fabric adds an element of compromise.<br />
          <strong style={{ color: '#c43235' }}>Gradients</strong> - Complicated gradients can sew very well. Stitches do not blend, so the gradient will be less smooth than on your computer screen.
        </p>

        <h3>File Types</h3>
        <p><strong>Preferred Format</strong></p>
        <p>
          Vector files created in Adobe Illustrator (ai, eps, pdf) with fonts converted to outlines produce the highest quality embroidery. These files use paths instead of pixels, allowing perfect scaling and stitch definition.
        </p>
      </div>

      {/* Illustrator Logos */}
      <div className="illustrator-logos flex flex-wrap justify-center gap-6 mb-8">
        <div className="text-center">
          <img
            src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_The_Artwork/Embroidery_Artwork_Adobe_Illustrator_Logo_Color_Sharprint.jpg?width=200"
            alt="Adobe Illustrator Color Logo"
            style={{ width: 200 }}
          />
          <p style={{ fontSize: 11 }}>Here is our Sharprint logo as a vector file.</p>
        </div>
        <div className="text-center">
          <img
            src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_The_Artwork/Embroidery_Artwork_Adobe_Illustrator_Logo_White_Sharprint.png?width=200"
            alt="Adobe Illustrator Logo Paths"
            style={{ width: 200 }}
          />
          <p style={{ fontSize: 11 }}>
            In this image, you can see the paths that make up the logo.
          </p>
        </div>
      </div>
      

      {/* Photoshop Logos */}
      <div className="photoshop-logos flex flex-wrap justify-center gap-6">
        <div className="text-center">
          <p><strong>Acceptable Format</strong></p>
          <p>
            Raster files created in Adobe Photoshop (jpg, tif, gif, png, eps) at a minimum of 150dpi at final size. These images are composed of pixels, so a digitizer must do some creative estimating. Your end embroidery may not be as exact as desired.
          </p>
          <img
            src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_The_Artwork/Embroidery_Artwork_Adobe_Photoshop_Logo_Color_Sharprint.jpg?width=200"
            alt="Adobe Photoshop Color Logo"
            style={{ width: 200 }}
          />
          <p style={{ fontSize: 11 }}>Here is the same Sharprint logo as a raster file.</p>
        </div>
        <div className="text-center">
          <img
            src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_The_Artwork/Embroidery_Artwork_Adobe_Photoshop_Logo_Color_Raster_Sharprint.jpg?width=200"
            alt="Photoshop Logo Pixels"
            style={{ width: 200 }}
          />
          <p style={{ fontSize: 11 }}>
            When zoomed in, you can see the pixels that make up the logo. Notice how the color areas are not as clearly defined.
          </p>
        </div>
      </div>
    </section></>


  );
}
